import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'business_name', label: 'Supplier' },
  { key: 'contact_person', label: 'Contact Person' },
  { key: 'phone', label: 'Phone' },
  { key: 'mobile', label: 'Mobile' },
  { key: 'email', label: 'Email' },
  { key: 'purchase_orders_count', label: 'Purchase Orders', align: 'right' },
  { key: 'vendor_invoices_count', label: 'Vendor Invoices', align: 'right' },
];

export function SupplierRegisterReport() {
  return (
    <ReportView
      title="Supplier Register"
      description="Full supplier listing with contact details and purchase order/invoice counts."
      endpoint="/reports/procurement/supplier-register"
      columns={COLUMNS}
    />
  );
}
